import { Component, OnInit, Input, Output, EventEmitter, Renderer2, ElementRef } from '@angular/core';
import { encapsulation } from '../../../components/encapsulation';
import { UBXToast, UBXColor } from '../../../models';

@Component({
    selector: 'ubx-toast-slice',
    templateUrl: './toast-slice.component.html',
    host: { class: 'ubx-toast-slice flx pe:a' },
    encapsulation
})
export class UBXToastSliceComponent implements OnInit {
    @Input() toast: UBXToast;
    @Output() remove: EventEmitter<void> = new EventEmitter();

    Color = UBXColor;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
    ) { }

    ngOnInit() {
        this.appendClass(`clr:${this.toast.type}-900`);
    }

    setColor(klass: string, type: UBXColor, weight: number): string {
        return `${klass}:${type}-${weight}`;
    }
    setIcon(type: UBXColor): string {
        let color: string;
        switch (type) {
            case UBXColor.Inf: color = `status.info reg.cir`; break;
            case UBXColor.Scs: color = `interface.check reg.cir`; break;
            case UBXColor.Dgr: color = `alert.exclaimation reg.tri`; break;
            case UBXColor.Wrn: color = `alert.exclaimation reg.cir`; break;
        }
        return color;
    }

    close() {
        this.remove.emit();
    }

    private appendClass(name: string) {
        this.renderer.addClass(this.el.nativeElement, name);
    }
}
